import React from "react";
import { Button } from "react-bootstrap";
import { string, func } from "prop-types";
import { push } from "react-router-redux";
import yellowWarningIcon from "resources/images/warning-yellow@2x.png";
import { trackCheckoutFlowClick } from "utils/trackingFunctions";

const ErrorPage = ({ dispatch, demoLink }) => {
  /* ----------- Event Handlers ------------ */

  const handleGoToDashboard = () => {
    dispatch(push("/dashboard"));
  };

  const handleScheduleDemo = () => {
    trackCheckoutFlowClick("Clicked Schedule a call", "Checkout-Error-Page");
    window.open(demoLink, "_blank", "noopener");
  };

  return (
    <div className="page-wrapper loading-page-wrapper">
      <div className="d-flex align-items-center">
        <img
          src={yellowWarningIcon}
          width="16px"
          height="16px"
          className="mr-2"
          alt="warning"
        />{" "}
        <span className="font-weight-bold">Something unexpected happened.</span>
      </div>
      <p>No worries, our team is here to help you complete your purchase.</p>
      <div>
        <Button
          onClick={handleGoToDashboard}
          id="goToDashboardFromErrorPage"
          variant="outline-primary"
          className="mr-3 btn-border-bold"
        >
          Go to Dashboard
        </Button>
        <Button
          onClick={handleScheduleDemo}
          id="scheduleDemoFromErrorPage"
          variant="primary"
          className="btn-border-bold"
        >
          Schedule a Call
        </Button>
      </div>
    </div>
  );
};

ErrorPage.propTypes = {
  dispatch: func.isRequired,
  demoLink: string.isRequired,
};

export default ErrorPage;
